export const FLAG_DRUG_REFERENCE_TOOL = 'flag_drug_reference';

const KEY_SAFETY_NOTES_TAG_PREFIX = '<keysafetynotes';
const KEY_SAFETY_NOTES_TAG = /<keysafetynotes[\s>]/i;

/**
 * The Evidence package only needs this narrow transcript view. Harness-owned
 * item types stay on the app side and are structurally compatible with it.
 */
export interface DrugInteractionWarningTranscriptItem {
  kind: string;
  text?: string;
  name?: string;
  status?: string;
  result?: { is_error?: boolean } | null;
}

/**
 * The drug tool is a silent machine signal. Surface its fallback only once the
 * successful result and final answer are both present; a Key Safety Notes block
 * already carries the same caveat and therefore supersedes the fallback.
 */
export const shouldShowDrugInteractionWarning = (
  items: readonly DrugInteractionWarningTranscriptItem[],
  { isStreaming }: { isStreaming: boolean }
): boolean => {
  if (isStreaming) return false;

  let hasCompletedDrugReference = false;
  let hasAnswerText = false;
  let answerTextTail = '';

  for (const item of items) {
    if (item.kind === 'assistant_text') {
      const answerChunk = item.text ?? '';
      hasAnswerText ||= /\S/.test(answerChunk);

      // Keep only enough preceding text to catch a tag split across answer blocks.
      const tagCandidate = answerTextTail + answerChunk;
      if (KEY_SAFETY_NOTES_TAG.test(tagCandidate)) return false;
      answerTextTail = tagCandidate.slice(-KEY_SAFETY_NOTES_TAG_PREFIX.length);
      continue;
    }

    if (
      item.kind === 'tool_use' &&
      item.name === FLAG_DRUG_REFERENCE_TOOL &&
      item.status === 'complete' &&
      item.result != null &&
      item.result.is_error !== true
    ) {
      hasCompletedDrugReference = true;
    }
  }

  return hasCompletedDrugReference && hasAnswerText;
};
